import { z } from 'zod';
/* ==========================================================================
 *  Day recap contract (ADR-0032 §1 / ADR-0034 / T28.2)
 *
 *  GET /me/days/:date/recap — the evening "Day closed" note (handoff §7/§1):
 *  one derived sentence + one suggestion. Unlike the day feed's timeline
 *  (numbers/enums only, client-templated), the recap sentence IS a composed,
 *  localized string — it follows the pre-existing template-summary.ts /
 *  daily-summary precedent (ADR-0004), not the ADR-0032 timeline i18n
 *  invariant. `aiPhrased` marks Premium AI-phrased content so the client
 *  shows the sparkle glyph only when it's honestly AI (ADR-0034 §3).
 *
 *  Only meaningful once the day is closed — null before then (no 404; mirrors
 *  the `{ plan: null }` / `{ recap: null }` envelope convention used by
 *  other "nothing yet" resources in this API).
 * ========================================================================== */
export const dayRecapSchema = z.object({
    sentence: z.string(),
    suggestion: z.string(),
    /** True for the Premium AI-phrased variant (ADR-0034 Class 2, step
     *  `summary-day`); false for the Lite template (Class 1, no AI call). */
    aiPhrased: z.boolean(),
});
export const dayRecapResponseSchema = z.object({
    date: z.string().date(),
    recap: dayRecapSchema.nullable(),
});
//# sourceMappingURL=day-recap.js.map